import React, { useState, useEffect } from "react";
// moment
import moment from "moment";
// alerta
import SchedulingAlert from "../../../components/SchedulingAlert";
// service
import { createSchedule } from "../../../services/scheduling";
// componentes
import CardItem from "../../../components/CardItem";
// constantes
import { VIEW } from "../constants";

export default function ItemRoomTimes(props) {
  const { data, user, setStep, config, saved } = props;
  // alerta
  const [confirm, setConfirm] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  // esgotada
  const [noStock, setNoStock] = useState(false);
  // regra 1 por sala
  const [blockRoom, setBlockRoom] = useState(false);

  function createScheduleFunc() {
    createSchedule({
      eventId: user.idEvent,
      sala: data.sala,
      atividade: data.atividade,
      dataHoraInicio: data.dataHoraInicio,
      dataHoraFim: data.dataHoraFim,
      participantId: user.idPart,
    })
      .then((res) => {
        if (res.message === "CREATED") {
          setSuccess(true);
        } else if (res.message === "APPOINTMENT_MADE") {
          setError("Você já se inscreveu nessa atividade");
        } else if (res.message === "APPOINTMENT_MADE_IN_OTHER_TIME") {
          setError("Você já está inscrito em uma atividade nesse horário");
        } else if (res.message === "ALREADY_REGISTERED") {
          setError("Você já se cadastrou nessa atividade");
        } else {
          setError(
            "Erro ao se cadastrar na atividade, tente novamente em breve.",
          );
        }

        setConfirm(false);
      })
      .catch((error) => console.log("erro", error));
  }

  function formatDate(date) {
    if (!date) return "";

    const newDate = new Intl.DateTimeFormat("pt-BR", {
      timeZone: "America/Sao_Paulo",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(new Date(date));

    return newDate;
  }

  useEffect(() => {
    if (data.quantidadeMax <= data.quantidadeUtilizada) setNoStock(true);

    // regra de 1 por sala
    if (config.regra === "onePerDate") {
      var search = saved.find(
        (e) =>
          moment(e.dataHoraInicio).format("DD/MM/YYY") ===
          moment(data.dataHoraInicio).format("DD/MM/YYY"),
      );

      if (search) setBlockRoom(true);
    }

    if (new Date(data.dataHoraInicio) < new Date()) {
      setBlockRoom(true);
    }
  }, []);

  return (
    <>
      {confirm && (
        <SchedulingAlert
          warning
          title={`Deseja se inscrever em ${data.sala} - ${data.atividade}?`}
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => createScheduleFunc()}
          onCancel={() => setConfirm(false)}
        />
      )}
      {success && (
        <SchedulingAlert
          success
          title="Cadastro realizado com sucesso!"
          onConfirm={() => {
            setStep(VIEW.SAVED);
            setSuccess(false);
          }}
        />
      )}

      {error && (
        <SchedulingAlert error title="Ooops..." onConfirm={() => setError("")}>
          {error}
        </SchedulingAlert>
      )}

      <CardItem
        title={`${formatDate(data.dataHoraInicio)} - ${formatDate(data.dataHoraFim)}`}
        subtitle={data.atividade}
        trailingIcon="bx bx-add-to-queue"
        disabled={noStock || blockRoom}
        onClick={() => setConfirm(true)}
      />
    </>
  );
}
